import { gql } from 'apollo-angular';

export const CheckResearchIsReadyDocument = gql`
  query checkResearchIsReady($funnelId: Int!) {
    checkResearchIsReady(funnelId: $funnelId)
  }
`;
